import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { Button } from '../../../../components/elements/buttons/Button';

const Open = ({ questions, onClick }) => {
    const handleClick = useCallback(
        question => () => {
            return onClick(question, true);
        },
        [onClick]
    );

    return (
        <Row>
            {questions.map(question => (
                <Button
                    key={question.uid}
                    title={question.title}
                    onClick={handleClick(question)}
                    classes="btn btn btn-outline-light mx-4"
                />
            ))}
        </Row>
    );
};

Open.propTypes = {
    questions: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default React.memo(Open);
